import { render } from "./Contacts.vue?vue&type=template&id=632416a6&scoped=true"
import script from "./Contacts.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Contacts.vue?vue&type=script&charset=utf-8&lang=js"

import "./Contacts.vue?vue&type=style&index=0&id=632416a6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632416a6"]])

export default __exports__